<template>
    <div>
        <div v-show="flag == 'user'">
            <Common
                :isBtnShow="false"
                @handleSelectionChange="handleSelectionChange"
            ></Common>
            <el-row :gutter="20" v-if="tag.length">
                <el-col :span="24">
                    <!-- 展示tag   @click="selectTag(item.id)" -->
                    <el-card class="tagContanier" shadow="never">
                        <p>用户订阅tag：</p>
                        <el-tag
                            v-for="(item, index) in tag"
                            :key="item && item.id"
                            @click="selectTag(index)"
                            :type="item && item.colorFlag ? 'success' : ''"
                            >{{ item && item.tagName }}</el-tag
                        >
                    </el-card>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click="searchAct(tagIds)"
                        class="bottom"
                        >查询文章</el-button
                    >
                </el-col>
            </el-row>
        </div>

        <!-- 展示文章的表格  -->
        <div class="allActile" v-show="flag == 'article'">
            <div class="header">
                <el-button
                    type="info"
                    icon="el-icon-back"
                    circle
                    class="addBtn"
                    @click="back"
                ></el-button>
                <my-search
                    :inputArr="inputArr"
                    :searchParams="searchParams"
                    :order="1"
                    @searchEvent="searchEvent"
                />
            </div>
            <my-table
                ref="someActtle"
                flag="someActtle"
                :tableData="allActile"
                :tableHeader="actHeader"
                :loading="loading"
                @handleCurrentChange="handleCurrentChange"
                @handleRowdbClick="handleRowdbClick"
            />

            <my-pagination
                :childMsg="userPageParams"
                @callFather="noticeFather"
            />

            <div class="showCurrent">
                <p v-show="name">
                    当前选择文章为:
                    <span>{{ name }}</span>
                </p>
            </div>

            <el-button type="primary" @click="pushActile" class="send"
                >推送</el-button
            >
        </div>
    </div>
</template>

<script>
import Common from "./common.vue";
import { getTag, getTagAct, reqPush } from "@/network/autopush/message";
// 清除高亮

export default {
    name: "push_tag",
    components: {
        Common,
    },
    data() {
        return {
            name: "",
            flag: "user",
            loading: true,
            checkedUser: "",
            searchParams: {
                docTitle: "",
            },
            tag: [], //tag集合
            tagIds: [],
            allActile: [],
            actHeader: Object.freeze([
                {
                    name: "文章名称",
                    prop: "docTitle",
                },
            ]),
            userPageParams: {
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },
            // 推送文章的参数
            actileParams: {
                cids: [],
                docId: "",
                type: "1",
            },
            inputArr: [
                {
                    name: "docTitle",
                    defaultText: "请输入文章名称",
                },
            ],
        };
    },
    methods: {
        // 清除高亮
        clearActive() {
            this.name = "";
            this.actileParams.docId = "";
            this.$refs.someActtle.handleRowdbClick();
        },
        // 获取tag标签
        async getTag() {
            var arr = [];
            this.checkedUser.forEach((item) => {
                arr.push(item.id);
            });
            let { data } = await getTag({ userIds: arr });
            if (data.code == 200) {
                data.data.map((item) => {
                    if (item) {
                        item.colorFlag = false;
                    }
                });
                this.tag = data.data;
            }
        },
        // 点击tag
        selectTag(index) {
            var currentTag = this.tag[index];
            var { tagIds } = this;
            currentTag.colorFlag = !currentTag.colorFlag;
            // 绿色tag才发请求
            if (currentTag.colorFlag) {
                tagIds.push(currentTag.id);
            } else {
                // 删除tag
                tagIds.splice(tagIds.indexOf(currentTag.id), 1);
            }
        },

        async getActile(isSearch) {
            let params = {
                tagIds: this.tagIds,
                docTitle: this.searchParams.docTitle,
                current: isSearch ? 1 : this.userPageParams.currentPage,
                size: this.userPageParams.pageSize,
            };
            let { data } = await getTagAct(params);

            if (data.code == 200) {
                this.loading = false;
                this.allActile = data.data.records;
                this.userPageParams.total = data.data.total;
                if (isSearch) this.userPageParams.currentPage = 1;
            }

            //  判断是否需要删除高亮
            // let isHave = this.allActile.some((item) => {
            //   return item.id == this.actileParams.docId;
            // });

            // if (!isHave) {
            this.clearActive();

            // }
        },
        searchAct(tagIds) {
            if (!tagIds.length) {
                this.$message("请输入要选择的查询标签");
                return;
            }

            this.getActile(true);

            this.flag = "article";
        },
        back() {
            this.searchParams.docTitle = "";
            this.flag = "user";
        },
        // 搜索文章
        searchEvent() {
            this.getActile(true);
        },
        // 推送文章
        async pushActile() {
            var { docId, cids } = this.actileParams;
            // 文章不能为空
            if (docId == "") {
                this.$message({
                    message: "推送文章不能为空",
                    type: "warning",
                });
            }
            this.checkedUser.forEach((item) => {
                cids.push(item.clientId);
            });

            let { data } = await reqPush(this.actileParams);
            if (data.code == 200) {
                this.$message({
                    message: "推送成功",
                    type: "success",
                });

                // 清楚文章高亮和所选文章
                this.clearActive();
            }
        },
        //
        handleCurrentChange(val) {
            this.actileParams.docId = val.id;
            this.name = val.docTitle;
        },
        // 取消展示的文章
        handleRowdbClick(row) {
            this.actileParams.docId = "";
            if (row.docTitle == this.name) {
                this.name = "";
            }
        },
        // 分页器
        noticeFather(parm) {
            this.userPageParams.currentPage = parm.currentPage;
            this.userPageParams.pageSize = parm.pageSize;
            this.getActile();
        },
        // 选中用户有变动
        handleSelectionChange(val) {
            this.checkedUser = val;
            this.getTag();
            // 当勾选用户发生改变的时候就清空tag数组 和文章
            this.tagIds = [];
            this.allActile = [];
        },
    },
    watch: {
        tagIds(val) {
            if (!val.length) {
                this.allActile = [];
                this.clearActive();
            }
        },
    },
};
</script>

<style scoped lang="scss">
.tagContanier {
    // padding: 6px;
    .el-tag {
        margin: 6px;
    }
}
.send {
    margin: 10px 20px;
}
.allActile {
    margin-top: 20px;
}
.showCurrent {
    height: 20px;
}
p {
    color: #606266;
    font-size: 14px;
}
p span {
    font-size: 13px;
}

.header {
    height: 100px;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
}
.addBtn {
    margin: 0 10px 10px 20px;
}
.bottom {
    margin-top: 20px;
}
</style>
